import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';

type Variante = 'primario' | 'secundario' | 'vazado' | 'fantasma' | 'perigo';
type Tamanho = 'pequeno' | 'medio' | 'grande';

type Comum = {
  variante?: Variante;
  tamanho?: Tamanho;
  largo?: boolean;
  /** Troca o conteúdo por um girador e bloqueia o clique. */
  carregando?: boolean;
  icone?: ReactNode;
  iconeDireita?: ReactNode;
  children?: ReactNode;
};

function classes({ variante = 'primario', tamanho = 'medio', largo, children, icone }: Comum) {
  return [
    'btn',
    variante !== 'primario' && `btn--${variante}`,
    tamanho !== 'medio' && `btn--${tamanho}`,
    largo && 'btn--largo',
    // Sem texto e com ícone: vira botão quadrado em vez de pílula esticada.
    !children && icone && 'btn--icone',
  ]
    .filter(Boolean)
    .join(' ');
}

type PropsBotao = Comum & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'>;

export function Botao({
  variante,
  tamanho,
  largo,
  carregando,
  icone,
  iconeDireita,
  children,
  disabled,
  className,
  ...props
}: PropsBotao) {
  return (
    <button
      className={`${classes({ variante, tamanho, largo, children, icone })}${className ? ` ${className}` : ''}`}
      disabled={disabled || carregando}
      // Anuncia o estado de espera sem tirar o rótulo de quem usa leitor de tela.
      aria-busy={carregando || undefined}
      {...props}
    >
      {carregando ? (
        <span className="girador" />
      ) : (
        icone && <span className="btn__icone">{icone}</span>
      )}
      {children}
      {iconeDireita && !carregando && <span className="btn__icone">{iconeDireita}</span>}
    </button>
  );
}

type PropsLink = Comum & { para: string; estado?: unknown };

/** Mesma aparência do botão, mas navega — mantém o `<a>` semântico. */
export function BotaoLink({
  para,
  estado,
  variante,
  tamanho,
  largo,
  icone,
  iconeDireita,
  children,
}: PropsLink) {
  return (
    <Link to={para} state={estado} className={classes({ variante, tamanho, largo, children, icone })}>
      {icone && <span className="btn__icone">{icone}</span>}
      {children}
      {iconeDireita && <span className="btn__icone">{iconeDireita}</span>}
    </Link>
  );
}
